/**
 * OhiClaw V0.1 — user-visible product name only.
 * Gateway URLs, `openclaw` CLI, config paths, and custom element tags stay
 * upstream-compatible.
 */
export const BRAND_PRODUCT_NAME = "OhiClaw";
export const BRAND_CONTROL_UI_TITLE = `${BRAND_PRODUCT_NAME} Control`;
